import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import PageTitle from "@insightfulscience/smart-react/PageTitle";
import ErrorLayout from "./ErrorLayout";

function Error503() {
	return (
		<ErrorLayout>
			<PageTitle title="Service Unavailable - OMIQ" />
			<Heading Tag="h1" size="xl" center className="mb-6 text-color-3">
				Service Unavailable
			</Heading>
			<Paragraph size="s" center className="">
				We’re sorry. We’re temporarily unavailable.
			</Paragraph>
		</ErrorLayout>
	);
}

export default Error503;
